import { matchValues } from '@shared/core/types/common';

const tickIndicator: OLO.Types.TICK_INDICATOR[] = [15, 30, 60, 120];

export const tickIndicatorType = matchValues(...tickIndicator);
